"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5582],{

/***/ 62645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export CustomFileInputWrapper */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55150);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  .nonHover {\n    overflow: auto;\n    border-width: 2px;\n    border-style: dashed;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    min-height: 100px;\n    border-color: ",
        ";\n  }\n\n  .nonHover .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid #6c757d;\n    padding: 10px;\n  }\n\n  .fileList {\n    overflow: auto;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    & .fileName {\n      cursor: pointer;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      transition: none;\n    }\n    & .fileName:hover {\n      color: #3bb77e;\n    }\n\n    & .fileSize {\n      margin-left: 6px;\n      color: rgb(100 116 139);\n    }\n  }\n\n  .fileList:hover {\n    background-color: rgb(203, 213, 225, 0.3);\n  }\n\n  .noFiles {\n    border-style: dashed;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .deleteBtn {\n    cursor: pointer;\n  }\n  .deleteBtn:hover {\n    color: #dc3545;\n  }\n\n  .fileInputHover {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    min-height: 100px;\n    border-style: dashed;\n    border-width: 3px;\n    border-radius: 10px;\n    border-color: #3bb77e;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #3bb77e;\n    cursor: pointer;\n    background-color: #fff;\n  }\n\n  .fileInputLabel {\n    height: 100%;\n    min-height: 100px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    margin: 0;\n  }\n\n  .fileInputLabel:hover {\n    color: #3bb77e;\n    background-color: #fff;\n    margin: 0;\n  }\n\n  .fileImg {\n    max-width: 24px;\n    font-size: 24px;\n    font-weight: 300;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var CustomFileInputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e8abcfa3-0"
})(_templateObject(), function(props) {
    return props.$error ? "#dc3545" : "#6c757d";
});
var CustomFileInput = function(props) {
    // 각 항목 클릭시 임시 다운로드
    // handleFiles 로 끌어올림
    var handleFiles = props.handleFiles, max = props.max, ment = props.ment, reset = props.reset, error = props.error;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), files = ref1[0], setFiles = ref1[1];
    var hoverRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var nonHoverRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var handleDrop = function(e) {
        e.preventDefault();
        if (hoverRef.current) hoverRef.current.style.visibility = "hidden";
        if (nonHoverRef.current) nonHoverRef.current.style.visibility = "visible";
        var droppedFiles = Array.from(e.dataTransfer.files);
        var tempArr = _toConsumableArray(files).concat(_toConsumableArray(droppedFiles));
        if (max && tempArr.length > max) {
            (0,_alert__WEBPACK_IMPORTED_MODULE_2__/* .failAlert */ .qh)("\uD30C\uC77C\uC740 \uCD5C\uB300 ".concat(max, "\uAC1C\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4."));
            setFiles(tempArr.slice(0, max));
            return;
        }
        setFiles(tempArr);
    };
    var handleDragOver = function(e) {
        e.preventDefault();
        if (hoverRef.current) hoverRef.current.style.visibility = "visible";
        if (nonHoverRef.current) nonHoverRef.current.style.visibility = "hidden";
    };
    var handleDragLeave = function(e) {
        e.preventDefault();
        if (hoverRef.current) hoverRef.current.style.visibility = "hidden";
        if (nonHoverRef.current) nonHoverRef.current.style.visibility = "visible";
    };
    var onChangeFiles = function(e) {
        var fileList = e.target.files ? Array.from(e.target.files) : [];
        var tempArr = _toConsumableArray(files).concat(_toConsumableArray(fileList));
        if (max && tempArr.length > max) {
            (0,_alert__WEBPACK_IMPORTED_MODULE_2__/* .failAlert */ .qh)("\uD30C\uC77C\uC740 \uCD5C\uB300 ".concat(max, "\uAC1C\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4."));
            setFiles(tempArr.slice(0, max));
            e.target.value = "";
            return;
        }
        setFiles(tempArr);
        e.target.value = "";
    };
    var deleteFile = function(i) {
        var tempArr = _toConsumableArray(files);
        tempArr.splice(i, 1);
        setFiles(tempArr);
    };
    var fileTypeCheck = function(name) {
        var ref;
        var key = (ref = name.split(".").pop()) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        switch(key){
            case "txt":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/txt.png"
                });
            case "doc":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/doc.png"
                });
            case "docx":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/docx.png"
                });
            case "jpg":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/jpg.png"
                });
            case "jpeg":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/jpeg.png"
                });
            case "png":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/png.png"
                });
            case "gif":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/gif.png"
                });
            case "mp3":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/mp3.png"
                });
            case "wav":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/wav.png"
                });
            case "wmv":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/wmv.png"
                });
            case "flac":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/flac.png"
                });
            case "mp4":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/mp4.png"
                });
            case "avi":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/avi.png"
                });
            case "mkv":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/mkv.png"
                });
            case "pdf":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/pdf.png"
                });
            case "zip":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/zip.png"
                });
            case "xls":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/xls.png"
                });
            case "ppt":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/ppt.png"
                });
            case "pptx":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/ppt.png"
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/file.png"
                });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (handleFiles) {
            handleFiles(files);
        }
        if (reset) {
            reset(files);
        }
    }, [
        files
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CustomFileInputWrapper, {
            className: "d-flex flex-colum w-100 position-relative",
            $error: error,
            children: [
                files && files.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: "nonHover",
                    className: "nonHover",
                    onDragOver: handleDragOver,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "header",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "d-flex align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "me-3",
                                            children: [
                                                "\uCCA8\uBD80\uD30C\uC77C ",
                                                files.length,
                                                "\uAC1C"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "",
                                            children: [
                                                (files.reduce(function(acc, cur) {
                                                    return acc + cur.size;
                                                }, 0) / 1024).toFixed(2),
                                                "KB"
                                            ]
                                        })
                                    ]
                                }),
                                (!max || files.length < max) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    role: "button",
                                    className: "d-flex align-items-center text-primary",
                                    htmlFor: "fileInput",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fi-rs-file-import me-1"
                                        }),
                                        "\uD30C\uC77C \uCD94\uAC00"
                                    ]
                                })
                            ]
                        }),
                        files.map(function(file, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "fileList",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "d-flex align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "me-2 fileImg",
                                                children: fileTypeCheck(file.name)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "fileName",
                                                onClick: function() {
                                                    var url = URL.createObjectURL(file);
                                                    var a = document.createElement("a");
                                                    a.href = url;
                                                    a.target = "_blank";
                                                    a.click();
                                                },
                                                children: file.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "fileSize",
                                                children: "(" + (file.size / 1024).toFixed(2) + "KB)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "deleteBtn",
                                            onClick: function() {
                                                return deleteFile(i);
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fi-rs-cross w-6 h-6"
                                            })
                                        })
                                    })
                                ]
                            }, i);
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "nonHover",
                    className: "nonHover noFiles",
                    style: {
                        visibility: "visible"
                    },
                    onDragOver: handleDragOver,
                    onDrop: handleDrop,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                            id: "fileInputLabel",
                            htmlFor: "fileInput",
                            className: "fileInputLabel",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "d-flex align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fi-rs-file-import me-2"
                                        }),
                                        ment ? ment : "\uD30C\uC77C\uC744 \uB4DC\uB798\uADF8 \uD558\uAC70\uB098 \uD074\uB9AD\uD558\uC138\uC694."
                                    ]
                                }),
                                max && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "ms-2",
                                    children: [
                                        "(\uCD5C\uB300 ",
                                        max,
                                        "\uAC1C)"
                                    ]
                                })
                            ]
                        })
                    })
                }),
                (!max || files.length < max) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "hover",
                    className: "fileInputHover",
                    style: {
                        visibility: "hidden"
                    },
                    onDragLeave: handleDragLeave,
                    onDrop: handleDrop,
                    onDragOver: handleDragOver,
                    ref: hoverRef,
                    children: "\uD30C\uC77C \uCD94\uAC00"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    type: "file",
                    multiple: !max || max > 1,
                    id: "fileInput",
                    className: "visually-hidden",
                    onChange: onChangeFiles
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomFileInput);


/***/ }),

/***/ 74905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rk": function() { return /* binding */ AccordionBox; },
/* harmony export */   "X1": function() { return /* binding */ AccordionBody; },
/* harmony export */   "_m": function() { return /* binding */ AccordionHeader; },
/* harmony export */   "il": function() { return /* binding */ AccordionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #ececec;\n  border-radius: 5px;\n  overflow: hidden;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 10px;\n  border-bottom: ",
        ";\n  cursor: pointer;\n  :hover {\n    background-color: #ececec55;\n  }\n  color: #1b1b1b;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 18px;\n  font-weight: 500;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0px 16px;\n  transition: all 0.1s linear;\n  overflow: hidden;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var AccordionBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab5a09fb-0"
})(_templateObject());
var AccordionHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab5a09fb-1"
})(_templateObject1(), function(props) {
    return props.active ? "1px solid #ececec" : "0px";
});
var AccordionTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab5a09fb-2"
})(_templateObject2());
var AccordionBody = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ab5a09fb-3"
})(_templateObject3(), function(props) {
    return props.active ? "height: 100%;  padding: 16px;" : "height: 0px;  padding: 0px 16px;";
});


/***/ }),

/***/ 44025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin: 8px 0px;\n  > input {\n    border: 1px solid #ececec;\n    border-radius: 10px;\n    box-shadow: none;\n    font-size: 16px;\n    width: 100%;\n    padding: 15px 20px 16px;\n    height: 60px;\n    cursor: ",
        ";\n    border-color: ",
        ";\n    :focus {\n      padding-top: 16px;\n      padding-bottom: 6px;\n      border-color: ",
        ";\n    }\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 16px 20px 16px;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: 1px solid transparent;\n  margin: 0px;\n  opacity: 1;\n  transform-origin: 0 0;\n  transform: ",
        ";\n  transition: transform 0.2s ease-in-out;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  color: #e74c3c;\n  font-size: 13px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var FloatingInputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9f157107-0"
})(_templateObject(), function(props) {
    return props.cursor;
}, function(props) {
    return props.$error ? "#e74c3c" : "#ececec";
}, function(props) {
    return props.$error ? "#e74c3c" : "#3bb77e";
}, function(props1) {
    return props1.value && "padding-top: 16px;\n      padding-bottom: 6px;\n      border-color: ".concat(function(props) {
        return props.$error ? "#e74c3c" : "#3bb77e";
    }, ";\n    ");
});
var FloatingLabel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-9f157107-1"
})(_templateObject1(), function(props) {
    return props.focused || props.value ? "scale(0.8) translateY(-0.6rem) translateX(0.2rem)" : "";
});
var Error = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9f157107-2"
})(_templateObject2());
var FloatingInput = function(props) {
    var placeholder = props.placeholder, value = props.value, onChange = props.onChange, readOnly = props.readOnly, onClick = props.onClick, type = props.type, min = props.min, max = props.max, name = props.name, register = props.register, error = props.error;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), focused = ref[0], setFocused = ref[1];
    var handleFocus = function() {
        return setFocused(true);
    };
    var handleBlur = function() {
        return setFocused(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FloatingInputWrapper, {
            onClick: function() {
                return onClick && onClick();
            },
            cursor: onClick ? "pointer" : "auto",
            $error: error,
            value: value,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FloatingLabel, {
                    htmlFor: "input",
                    focused: focused,
                    value: value,
                    children: placeholder
                }),
                register ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({
                    id: "input",
                    name: name,
                    type: "text",
                    onFocus: handleFocus,
                    readOnly: readOnly,
                    min: min || "",
                    value: value
                }, register(name), {
                    onBlur: handleBlur
                })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    id: "input",
                    type: type || "text",
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    value: value || "",
                    onChange: onChange,
                    readOnly: readOnly,
                    min: min || ""
                }),
                error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Error, {
                    children: error.message
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FloatingInput);


/***/ }),

/***/ 10103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FB": function() { return /* binding */ registerValidationSchema; },
/* harmony export */   "JW": function() { return /* binding */ GPTypeTwoSchema; },
/* harmony export */   "Ly": function() { return /* binding */ GPTypeFourSchema; },
/* harmony export */   "Nd": function() { return /* binding */ findIdValidationSchema; },
/* harmony export */   "UT": function() { return /* binding */ findPwValidationSchema; },
/* harmony export */   "gW": function() { return /* binding */ GPTypeThirdSchema; },
/* harmony export */   "i1": function() { return /* binding */ findPwReqValidationSchema; },
/* harmony export */   "lI": function() { return /* binding */ GPTypeOneSchema; },
/* harmony export */   "te": function() { return /* binding */ findIdReqValidationSchema; },
/* harmony export */   "zq": function() { return /* binding */ editUserInfoValidationSchema; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);

var registerValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    uid: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(6, "6\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.").matches(/^[a-zA-Z0-9]*$/, "\uC544\uC774\uB514\uB294 \uC601\uBB38 \uD639\uC740 \uC601\uBB38\uACFC \uC22B\uC790 \uC870\uD569\uC73C\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    upass: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_()// .length(8, "8자 이상 입력해주세요.")
    .matches(/^.{8,}$/, "\uCD5C\uC18C 8\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    reupass: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().oneOf([
        yup__WEBPACK_IMPORTED_MODULE_0__/* .ref */ .iH("upass")
    ], "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.").required("\uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("\uC774\uBA54\uC77C \uD615\uC2DD\uC744 \uB2E4\uC2DC \uD655\uC778\uD574\uC8FC\uC138\uC694.").required("\uC774\uBA54\uC77C\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(10, "10\uC790 \uC774\uC0C1, \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.").max(11, "11\uC790 \uC774\uD558, \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.").matches(/^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/, "\uC5F0\uB77D\uCC98 \uD615\uC2DD\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.").required("\uC5F0\uB77D\uCC98\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.")
});
var editUserInfoValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    uid: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(6, "6\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.").matches(/^[a-zA-Z0-9]*$/, "\uC544\uC774\uB514\uB294 \uC601\uBB38 \uD639\uC740 \uC601\uBB38\uACFC \uC22B\uC790 \uC870\uD569\uC73C\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("\uC774\uBA54\uC77C \uD615\uC2DD\uC744 \uB2E4\uC2DC \uD655\uC778\uD574\uC8FC\uC138\uC694.").required("\uC774\uBA54\uC77C\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.")
});
var findPwValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    uid: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(/^[a-zA-Z0-9]*$/, "\uC544\uC774\uB514\uB294 \uC601\uBB38 \uD639\uC740 \uC601\uBB38\uACFC \uC22B\uC790 \uC870\uD569\uC73C\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uB4F1\uB85D\uD55C \uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(10, "10\uC790 \uC774\uC0C1, \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.").max(11, "11\uC790 \uC774\uD558, \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.").matches(/^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/, "\uC5F0\uB77D\uCC98 \uD615\uC2DD\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.").required("\uC5F0\uB77D\uCC98\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.")
});
var findPwReqValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    num: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(/^([0-9]{6})$/, "\uC778\uC99D\uBC88\uD638 \uC22B\uC790 6\uC790\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uC778\uC99D\uBC88\uD638 6\uC790\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    upass: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(/^.{8,}$/, "\uCD5C\uC18C 8\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uB4F1\uB85D\uD560 \uC0C8 \uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    reupass: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().oneOf([
        yup__WEBPACK_IMPORTED_MODULE_0__/* .ref */ .iH("upass"),
        null
    ], "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.").required("\uB3D9\uC77C\uD55C \uBE44\uBC00\uBC88\uD638\uB97C \uB2E4\uC2DC \uC785\uB825\uD574\uC8FC\uC138\uC694.")
});
var findIdValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uB4F1\uB85D\uD55C \uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694."),
    phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().min(10, "10\uC790 \uC774\uC0C1, \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.").max(11, "11\uC790 \uC774\uD558, \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.").matches(/^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/, "\uC5F0\uB77D\uCC98 \uD615\uC2DD\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.").required("\uC5F0\uB77D\uCC98\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.")
});
var findIdReqValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    num: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(/^([0-9]{6})$/, "\uC778\uC99D\uBC88\uD638 \uC22B\uC790 6\uC790\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.").required("\uC778\uC99D\uBC88\uD638 6\uC790\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.")
});
var GPTypeOneSchema = function(param) {
    var min = param.min, rounding = param.rounding, max = param.max;
    return yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
        cnt: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().required("\uC8FC\uBB38 \uC218\uB7C9\uC740 \uD544\uC218 \uC785\uB2C8\uB2E4.").transform(function(value, originalValue) {
            return isNaN(originalValue) ? undefined : Number(originalValue);
        }).test("roundTest", "\uBB36\uC74C \uB2E8\uC704\uB97C \uD655\uC778\uD558\uC138\uC694", function(value, context) {
            var check = true;
            if (value % rounding) {
                check = false;
            }
            if (!check) {
                return context.createError({
                    path: context.path,
                    message: "".concat(rounding, " \uB2E8\uC704\uB85C \uC8FC\uBB38 \uAC00\uB2A5\uD569\uB2C8\uB2E4.")
                });
            }
            return check;
        }).test("is-not-nan", "\uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.", function(value) {
            return !isNaN(value);
        }).min(min || 500, "\uCD5C\uC18C \uC8FC\uBB38 \uC218\uB7C9\uC740 ".concat(min || 500, "\uAC1C \uC785\uB2C8\uB2E4.")).max(max || 9999999, "\uCD5C\uB300 \uC8FC\uBB38 \uC218\uB7C9\uC740 ".concat(max || 99999999, "\uAC1C \uC785\uB2C8\uB2E4.")),
        company: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC5C5\uCCB4\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
        name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uB2F4\uB2F9\uC790\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
        phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC5F0\uB77D\uCC98\uB294 \uD544\uC218\uC785\uB2C8\uB2E4."),
        email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC774\uBA54\uC77C\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
        doro_addr: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC8FC\uC18C \uD544\uC218\uC785\uB2C8\uB2E4."),
        detail_addr: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC0C1\uC138\uC8FC\uC18C\uB294 \uD544\uC218\uC785\uB2C8\uB2E4."),
        editYn: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uB514\uC790\uC778 \uC791\uC5C5 \uC120\uD0DD\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
        memo: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
        file: yup__WEBPACK_IMPORTED_MODULE_0__/* .mixed */ .nK().required("\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694.").test("is-fileList", "\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694.", function(value) {
            if (!value) return false; // 파일이 없는 경우
            if (Object.prototype.toString.call(value) === "[object File]") {
                return Object.prototype.toString.call(value) === "[object File]";
            } else {
                return Object.prototype.toString.call(value) === "[object FileList]";
            }
        })
    });
};
var GPTypeTwoSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    company: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uD68C\uC0AC\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC2E0\uCCAD\uC790\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC5F0\uB77D\uCC98\uB294 \uD544\uC218\uC785\uB2C8\uB2E4."),
    cnt: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().transform(function(value, originalValue) {
        return isNaN(originalValue) ? undefined : Number(originalValue);
    }).test("is-not-nan", "\uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694.", function(value) {
        return !isNaN(value);
    }).required("\uAD50\uC721 \uCC38\uAC00 \uC778\uC6D0\uC740 \uD544\uC218 \uC785\uB2C8\uB2E4.").min(1, "\uCD5C\uC18C \uCC38\uAC00 \uC778\uC6D0\uC740 1\uBA85 \uC785\uB2C8\uB2E4."),
    check: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().isTrue("\uC815\uBCF4\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uCCB4\uD06C\uD574\uC8FC\uC138\uC694.").required("\uC815\uBCF4\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uCCB4\uD06C\uD574\uC8FC\uC138\uC694.")
});
var GPTypeThirdSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    company: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uD68C\uC0AC\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC2E0\uCCAD\uC790\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC5F0\uB77D\uCC98\uB294 \uD544\uC218\uC785\uB2C8\uB2E4."),
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("\uC62C\uBC14\uB978 \uC774\uBA54\uC77C \uD615\uC2DD\uC774 \uC544\uB2D9\uB2C8\uB2E4.").required("\uC774\uBA54\uC77C\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    memo: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uBB38\uC758 \uB0B4\uC6A9\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    file: yup__WEBPACK_IMPORTED_MODULE_0__/* .mixed */ .nK().required("\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694.").test("is-fileList", "\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694.", function(value) {
        if (!value) return false; // 파일이 없는 경우
        if (Object.prototype.toString.call(value) === "[object File]") {
            return Object.prototype.toString.call(value) === "[object File]";
        } else {
            return Object.prototype.toString.call(value) === "[object FileList]";
        }
    }),
    check: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().isTrue("\uC815\uBCF4\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uCCB4\uD06C\uD574\uC8FC\uC138\uC694.").required("\uC815\uBCF4\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uCCB4\uD06C\uD574\uC8FC\uC138\uC694.")
});
var GPTypeFourSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape({
    company: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uD68C\uC0AC\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    name: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC2E0\uCCAD\uC790\uBA85\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    phone: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC5F0\uB77D\uCC98\uB294 \uD544\uC218\uC785\uB2C8\uB2E4."),
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("\uC62C\uBC14\uB978 \uC774\uBA54\uC77C \uD615\uC2DD\uC774 \uC544\uB2D9\uB2C8\uB2E4.").required("\uC774\uBA54\uC77C\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    memo: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uBB38\uC758 \uB0B4\uC6A9\uC740 \uD544\uC218\uC785\uB2C8\uB2E4."),
    file: yup__WEBPACK_IMPORTED_MODULE_0__/* .mixed */ .nK().required("\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694.").test("is-fileList", "\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694.", function(value) {
        if (!value) return false; // 파일이 없는 경우
        if (Object.prototype.toString.call(value) === "[object File]") {
            return Object.prototype.toString.call(value) === "[object File]";
        } else {
            return Object.prototype.toString.call(value) === "[object FileList]";
        }
    }),
    doro_addr: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC8FC\uC18C \uD544\uC218\uC785\uB2C8\uB2E4."),
    detail_addr: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("\uC0C1\uC138\uC8FC\uC18C\uB294 \uD544\uC218\uC785\uB2C8\uB2E4."),
    check: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().isTrue("\uC815\uBCF4\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uCCB4\uD06C\uD574\uC8FC\uC138\uC694.").required("\uC815\uBCF4\uC774\uC6A9 \uB3D9\uC758\uC5D0 \uCCB4\uD06C\uD574\uC8FC\uC138\uC694.")
});


/***/ }),

/***/ 11282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fi": function() { return /* binding */ GuestWrapper; },
/* harmony export */   "Kk": function() { return /* binding */ DetailSection; },
/* harmony export */   "M5": function() { return /* binding */ StickyHeader; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "c0": function() { return /* binding */ DetailWrapper; },
/* harmony export */   "ed": function() { return /* binding */ StickyBody; },
/* harmony export */   "hI": function() { return /* binding */ StickySection; },
/* harmony export */   "mo": function() { return /* binding */ InfoWrapper; },
/* harmony export */   "oW": function() { return /* binding */ StickyFooter; },
/* harmony export */   "q$": function() { return /* binding */ InfoRow; },
/* harmony export */   "vb": function() { return /* binding */ TimerWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n\n  @media screen and (max-width: 991px) {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 65%;\n  padding: 30px 50px 30px 0px;\n  word-break: break-all;\n  @media screen and (max-width: 991px) {\n    width: 100%;\n    padding: 16px 10px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 74px;\n  display: flex;\n  flex-direction: column;\n  width: 35%;\n  height: ",
        ";\n  padding: 16px 10px;\n\n  @media screen and (max-width: 991px) {\n    width: 100%;\n    position: relative;\n    height: auto;\n    top: 0%;\n    border-top: 2px solid #ececec;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  & h4 {\n    margin-bottom: 24px;\n  }\n\n  & i {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 2px;\n    margin-right: 3px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: auto;\n  margin-bottom: 1rem;\n  padding-right: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  font-size: 16px;\n  border: 1px solid #ececec;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 400;\n  border-bottom: 1px solid #ececec;\n  padding: 10px 5px;\n  :last-of-type {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n\n  .confirm {\n    width: 100%;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n\n  & h6 {\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n  }\n\n  & span {\n    font-size: 1rem;\n    color: #253d4e;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2a8cb705-0"
})(_templateObject());
var DetailWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2a8cb705-1"
})(_templateObject1());
var DetailSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-2a8cb705-2"
})(_templateObject2());
var StickySection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-2a8cb705-3"
})(_templateObject3(), function(props) {
    return props.$scroll ? "calc(100vh - 73px)" : "calc(100vh - 305px)";
});
var StickyHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2a8cb705-4"
})(_templateObject4());
var StickyBody = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2a8cb705-5"
})(_templateObject5());
var InfoWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2a8cb705-6"
})(_templateObject6());
var InfoRow = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2a8cb705-7"
})(_templateObject7());
var StickyFooter = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2a8cb705-8"
})(_templateObject8());
var GuestWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2a8cb705-9"
})(_templateObject9());
var TimerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2a8cb705-10"
})(_templateObject10());


/***/ }),

/***/ 88911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ TypeOneSection; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var TypeOneSection = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-1c8ccb9e-0"
})(_templateObject());


/***/ })

}]);